<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="24">
          <el-card class="box-card">
            <h4 class="card-title">Classroom Register</h4>
            <div class="card-header">

              <div class="card-content">

                <el-row style="margin-top:30px; margin-bottom: 10px">

                  <el-button class="btn btn-primary" :loading="loadingRegister" @click="openRegister">Download Register</el-button>

                </el-row>
<div class="table-responsive">
                <data-tables-server 
                                    class="el-table table-shopping el-table--fit el-table--scrollable-x el-table--enable-row-hover el-table--enable-row-transition" 

                  style="width: 100%" 
                  :data="register" 
                  :tool-bar="false" 
                  :current-page="1" 
                  :total="total"
                  :loading="loadingRegister"
                  :page-size="50"
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">
<el-table-column label="ID" min-width="10">
                    <template slot-scope="props">{{props.row.customer.id}}</template>
                  </el-table-column>
                  <el-table-column label="First Name" min-width="10">
                    <template slot-scope="props">{{props.row.customer.firstname}}</template>
                  </el-table-column>

                  <el-table-column label="Last Name" min-width="10">
                    <template slot-scope="props">{{props.row.customer.lastname}}</template>
                  </el-table-column>

                  <el-table-column label="Email" min-width="10">
                    <template slot-scope="props">{{props.row.customer.email}}</template>
                  </el-table-column>

                  <el-table-column label="Attended" min-width="10">
                    <template slot-scope="props">
                      <el-switch
                        v-model.number="props.row.attended"
                        @change="setUserAttended(props.row.id, props.row.attended, props.row.customer.id)"
                        active-text="Yes"
                        :active-value=1
                        inactive-text="No"
                        :inactive-value=0>
                      </el-switch>
                    </template>
                  </el-table-column>

                  <el-table-column label="Passed" min-width="10">
                    <template slot-scope="props">
                      <el-switch
                        v-model.number="props.row.passed"
                        @change="setUserPassed(props.$index, props.row)"
                        active-text="Yes"
                        :active-value=1
                        inactive-text="No"
                        :disabled="props.row.passed==1?true:false"
                        :inactive-value=0>
                      </el-switch>
                    </template>
                  </el-table-column>

                  <el-table-column label="Reference Letter" min-width="10">
                    Edit
                    <template slot-scope="props" >
                      
                      <div v-if="props.row.lorSourceUrl"><a  :href="props.row.lorSourceUrl"><i class="fa fa-download"></i>view</a> <a :href="'/#/tutors/lor/'+props.row.id">Edit</a></div>
                      <a v-else :href="'/#/tutors/lor/'+props.row.id">Create</a>
                      </template>
                  

                  </el-table-column>

                </data-tables-server>
</div>
              </div>
            </div>
            <div class="card-content"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<style>
.el-switch__label {
  color: #ccc;
}
</style>
<script>
import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      loadingRegsiter: false,
      classroom: {},
      register: [],
      printRegister: "",
      loadingRegister: false,
      total: 0,
      aggregate: {},
    };
  },
  methods: {
    getRegister(id) {
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          fetchPolicy: "no-cache",
          query: gql`
          {
            ClassRoomAttendee(
              where: { 
                  _and: [
                    { classRoomId: {_eq: "${id}"} }
                  ]
                }, order_by: {customerId: asc}
            ) {
              classRoomId
              customer {
                id
                firstname
                lastname
                email
              }
              dateUpdated
              attended
              lorSourceUrl
              passed
              id
              customerId
            }
            ClassRoomAttendee_aggregate(
              where: { 
                 _and: [
                    { classRoomId: {_eq: "${id}"} }
                  ]
                }
            ) {
              aggregate {
                count
              }
            }
          }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          },
        })
        .then((response) => {
          this.register = response.data.ClassRoomAttendee;
          console.log(this.register);
          this.aggregate = response.data.ClassRoomAttendee_aggregate.aggregate;
          this.total =
            response.data.ClassRoomAttendee_aggregate.aggregate.count;
          this.loadingRegister = false;
        });
    },

    setUserAttended(id, attended, customerId) {
      console.log("attended: ", id, attended, customerId);
      const q = gql`
        mutation update_ClassRoomAttendee(
          $id: Int
          $attended: smallint
          $customerId: Int
          $classroomId: Int
        ) {
          update_OrderBoughtProduct(
            where: {
              _and: {
                customerId: { _eq: $customerId,_is_null: false  }
                classRoomId: { _eq: $classroomId, _is_null: false }
              }
            }
            _set: { classRoomCourseAttended: $attended }
          ) {
            affected_rows
          }
          update_ClassRoomAttendee(
            where: { id: { _eq: $id } }
            _set: { attended: $attended }
          ) {
            affected_rows
            returning {
              id
              attended
              passed
            }
          }
        }
      `;

      this.$apollo

        .mutate({
          mutation: q,
          variables: {
            id: id,
            attended: attended,
            customerId: customerId,
            classroomId: this.classroom.id,
          },
        })

        .then((result) => {
          console.log('res',result)
          this.$notify({
            title: "Attendance Update",
            message: attended == 1 ? "Attended" : "Did not attend",
            type: "success",
          });
          //this.getRegister(this.$route.params.id);
          // return result
        })
        .catch((error) => {
          console.log(error)
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error",
          });
        });
    },

    setUserPassed(index, row) {
      console.log("passed: ", index, row);
      let flag = row.passed;
      // console.dir(this.currentPrice.prices[2])
      row.passed = row.passed == 0 ? 1 : 0;
      console.log(row.passed + ":" + flag);
      this.$confirm(
        `Please confirm ${row.customer.firstname} ${row.customer.lastname} ${
          row.passed == 1 ? "failed" : "passed"
        }`,
        "Confirm pass/fail",
        {
          confirmButtonText: `Confirm,  ${
            row.passed == 1 ? "failed" : "passed"
          }`,
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          if (flag == 1) {
            row.passed = 1;
            console.log("set passed");
            const q = gql`
              mutation update_ClassRoomAttendee(
                $id: Int
                $passed: smallint
                $customerId: Int
                $classroomId: Int
              ) {
                update_OrderBoughtProduct(
                  where: {
                    _and: {
                      customerId: { _eq: $customerId, _is_null: false }
                      classRoomId: { _eq: $classroomId, _is_null: false }

                    }
                  }
                  _set: { classRoomCoursePassed: $passed }
                ) {
                  affected_rows
                }
                update_ClassRoomAttendee(
                  where: { id: { _eq: $id } }
                  _set: { passed: $passed }
                ) {
                  affected_rows
                  returning {
                    id
                    attended
                    passed
                  }
                }
              }
            `;

            this.$apollo
              .mutate({
                mutation: q,
                variables: {
                  id: row.id,
                  passed: row.passed,
                  customerId: row.customerId,
                  classroomId: row.classRoomId,
                },
              })

              .then((result) => {
                console.log(result)
                this.$notify({
                  title: "Pass Updated",
                  message: row.passed == 1 ? "Passed" : "Failed",
                  type: "success",
                });
                //this.getRegister(this.$route.params.id);
                // return result
              })
              .catch((error) => {
                this.$notify({
                  title: "Error",
                  message: error.message,
                  type: "error",
                });
              });
          } else {
            console.log("Cancel");
            row.passed = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getClassroom() {
      return await this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: gql`
            {
              ClassRoom(where: {id: {_eq: "${this.register[0].classRoomId}"}}) {
                id
                sessions
                code
                startDate
                endDate
                startTime
                endTime
                length
                venue {
                  id
                  country
                  name
                  town
                }
                tutor {
                  id
                  firstname
                  lastname
                }
                attendees{
                  id
                  customer{
                    id
                    firstname
                    lastname
                    email
                  }
                }
                
              }
            }
          
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          },
        })
        .then((response) => {
          return (this.classroom = response.data.ClassRoom);
        });
    },
    async openRegister() {
      this.loadingRegister = true;
      let cRoom = await this.getClassroom();
      console.log("getting class");
      console.log(cRoom);
      api.getPrintRegister(cRoom[0]).then((res) => {
        var dataView = new DataView(res.data);
        var fileURL = window.URL.createObjectURL(
          new Blob([dataView], { type: "application/pdf" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          cRoom[0].venue.name + " - " + cRoom[0].startDate + " - register.pdf"
        );
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingRegister = false;
      });
    },
  },
  mounted() {
    this.getRegister(this.$route.params.id);
    //this.getClassroom(this.$route.params.id);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tutor/Register.vue